import { Stat } from "./Stat";
import { formatDistanceToNowStrict } from "date-fns";
import { useProjectDetailsParams } from "../hooks/useProjectDetailsParams";
import { useRoundById } from "../../../../context/RoundContext";
import { isInfiniteDate } from "../../../api/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectStats(props) {
  const {
    chainId,
    roundId
  } = useProjectDetailsParams();
  const {
    round
  } = useRoundById(Number(chainId), roundId);
  const application = props.application;
  const timeRemaining = round !== null && round !== void 0 && round.roundEndTime && !isInfiniteDate(round === null || round === void 0 ? void 0 : round.roundEndTime) ? formatDistanceToNowStrict(round.roundEndTime) : null;
  const isBeforeRoundEndDate = round && (isInfiniteDate(round.roundEndTime) || round.roundEndTime > new Date());
  return /*#__PURE__*/_jsxs("div", {
    className: "rounded-3xl flex-auto p-3 md:p-4 gap-4 flex flex-col text-blue-800",
    children: [/*#__PURE__*/_jsx(Stat, {
      isLoading: !application,
      value: `$${application === null || application === void 0 ? void 0 : application.totalAmountDonatedInUsd.toFixed(2)}`,
      children: "funding received in current round"
    }), /*#__PURE__*/_jsx(Stat, {
      isLoading: !application,
      value: application === null || application === void 0 ? void 0 : application.uniqueDonorsCount,
      children: "contributors"
    }), /*#__PURE__*/_jsx(Stat, {
      isLoading: isBeforeRoundEndDate === undefined,
      value: timeRemaining,
      className:
      // Explicitly check for true - could be undefined if round hasn't been loaded yet
      isBeforeRoundEndDate === true || isBeforeRoundEndDate === undefined ? "" : "flex-col-reverse",
      children:
      // If loading - render empty
      isBeforeRoundEndDate === undefined ? "" : isBeforeRoundEndDate ? "to go" : "Round ended"
    })]
  });
}